import Branch, { DeepLinkData } from 'branch-sdk';


const generateDynamicLink = async (urlSuffixName: string): Promise<string | null> => {
    try {
        const API_KEY = process.env.REACT_APP_BRANCH_IO_API_KEY;
        const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT ?? 'prod';
        const androidDeeplink = process.env.REACT_APP_ANDROID_DEEPLINK_PATH ?? 'quickasyst://';
        const iosDeeplink = process.env.REACT_APP_IOS_DEEPLINK_PATH ?? 'quickasyst://';
        const androidUrl = process.env.REACT_APP_ANDROID_URL ?? '';
        const iosUrl = process.env.REACT_APP_IOS_URL ?? '';
        if (!API_KEY) {
            throw new Error('Branch.io API key is not defined.');
        }
        if (!urlSuffixName || !urlSuffixName.trim()) {
            throw new Error('Please enter a URL suffix.');
        }
        Branch.init(API_KEY);
        const deepLinkData: DeepLinkData & {alias: string} = {
            tags: ['QuickAsyst Referral Link'],
            feature: 'share',
            stage: 'new user',
            alias: urlSuffixName,
            data: {
                $web_only: false,
                $android_deeplink_path: androidDeeplink,
                $ios_deeplink_path: iosDeeplink,
                ...(androidUrl && { $android_url: androidUrl }),
                ...(iosUrl && { $ios_url: iosUrl }),
                title: 'QuickAsyst Referral Link',
                contentDescription: `Deep link for user`,
                qac: urlSuffixName,
                customMetadata: {
                    referralCode: urlSuffixName,
                }
            }
        };        

        const generateLink = await new Promise<string | null>((resolve, reject) => {
            Branch.link(deepLinkData, (err: any, link: any) => {
                if (err) {
                    console.error('Error generating link', err);
                    reject(err);
                    return;
                }

                resolve(link);
            });
        });

        return generateLink;
    } catch (error: any) {
        const errorStr = error?.message || error?.toString();

        if (errorStr.includes('Link alias conflict')) {
            throw new Error('URL Suffix already exists');
        }

        console.error('Error generating dynamic link:', error);
        throw error;
    }
};

export default generateDynamicLink;